import Vue from "vue";
import VueRouter from "vue-router";
import Eisen from "../views/Eisen.vue";
import Swot from "../views/Swot.vue";
import Ikigai from "../views/Ikigai.vue";
import Moscow from "../views/Moscow.vue";
import Rice from "../views/Rice.vue";
import Procon from "../views/Procon.vue";
import ProductVision from "../views/ProductVision.vue";
import Smart from "../views/Smart.vue";
import Spade from "../views/Spade.vue";
import Kanban from "../views/Kanban.vue";
import Landing from "../views/Landing";
import Login from "@/components/Login";
import Signup from "@/components/Signup";
import UserBoard from "@/components/UserBoard";
import NotFound from "../views/NotFound.vue";
import HowItWorks from "../views/HowItWorks.vue";
import Discover from "../views/Discover.vue";
import Daci from "../views/Daci.vue";

import AboutEisen from "../views/about/Eisen.vue";
import AboutIkigai from "../views/about/Ikigai.vue";
import AboutKanban from "../views/about/Kanban.vue";
import AboutMoscow from "../views/about/Moscow.vue";
import AboutProcon from "../views/about/Procon.vue";
import AboutProductVision from "../views/about/ProductVision.vue";
import AboutRice from "../views/about/Rice.vue";
import AboutSmart from "../views/about/Smart.vue";
import AboutSpade from "../views/about/Spade.vue";
import AboutSwot from "../views/about/Swot.vue";
import AboutDaci from "../views/about/Daci.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Landing",
    component: Landing,
  },
  {
    path: "/how-it-works",
    name: "How It Works",
    component: HowItWorks,
  },
  {
    path: "/discover",
    name: "Discover",
    component: Discover,
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: {
      // transition: "fade,
      guest: true,
    },
  },
  {
    path: "/signup",
    name: "signup",
    component: Signup,
    meta: {
      guest: true,
    },
  },
  {
    path: "/dashboard",
    name: "userboard",
    component: UserBoard,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/eisen",
    name: "Eisen",
    component: Eisen,
    meta: {
      // transition: "fade-in-down",
      // requiresAuth: true,
    },
  },
  {
    path: "/eisen/about",
    name: "AboutEisen",
    component: AboutEisen,
  },
  {
    path: "/swot",
    name: "Swot",
    component: Swot,
    meta: {
      // requiresAuth: true,
    },
  },
  {
    path: "/swot/about",
    name: "AboutSwot",
    component: AboutSwot,
  },
  {
    path: "/ikigai",
    name: "Ikigai",
    component: Ikigai,
    meta: {
      // requiresAuth: true,
    },
  },
  {
    path: "/ikigai/about",
    name: "AboutIkigai",
    component: AboutIkigai,
  },
  {
    path: "/moscow",
    name: "Moscow",
    component: Moscow,
  },
  {
    path: "/moscow/about",
    name: "AboutMoscow",
    component: AboutMoscow,
  },
  {
    path: "/rice",
    name: "Rice",
    component: Rice,
    meta: {
      // requiresAuth: true,
    },
  },
  {
    path: "/rice/about",
    name: "AboutRice",
    component: AboutRice,
  },
  {
    path: "/procon",
    name: "Procon",
    component: Procon,
    meta: {
      // requiresAuth: true,
    },
  },
  {
    path: "/procon/about",
    name: "AboutProcon",
    component: AboutProcon,
  },
  {
    path: "/smart",
    name: "Smart",
    component: Smart,
    meta: {
      // requiresAuth: true,
    },
  },
  {
    path: "/smart/about",
    name: "AboutSmart",
    component: AboutSmart,
  },
  {
    path: "/kanban",
    name: "Kanban",
    component: Kanban,
    meta: {
      // requiresAuth: true,
    },
  },
  {
    path: "/kanban/about",
    name: "AboutKanban",
    component: AboutKanban,
  },
  {
    path: "/product-vision",
    name: "ProductVision",
    component: ProductVision,
    meta: {
      // requiresAuth: true,
    },
  },
  {
    path: "/product-vision/about",
    name: "AboutProductVision",
    component: AboutProductVision,
  },
  {
    path: "/spade",
    name: "Spade",
    component: Spade,
    meta: {
      // requiresAuth: true,
    },
  },
  {
    path: "/spade/about",
    name: "AboutSpade",
    component: AboutSpade,
  },
  {
    path: "/daci",
    name: "Daci",
    component: Daci,
    meta: {
      // requiresAuth: true,
    },
  },
  {
    path: "/daci/about",
    name: "AboutDaci",
    component: AboutDaci,
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "*",
    name: "404",
    component: NotFound,
  },
];

const router = new VueRouter({
  routes,
});

// router.beforeEach((to, from, next) => {
//   if (to.matched.some((record) => record.meta.requiresAuth)) {
//     if (localStorage.getItem("jwt") == null) {
//       next({
//         path: "/login",
//         params: { nextUrl: to.fullPath },
//       });
//     } else {
//       let user = JSON.parse(localStorage.getItem("user"));
//       if (to.matched.some((record) => record.meta.is_admin)) {
//         if (user.is_admin == 1) {
//           next();
//         } else {
//           next({ name: "userboard" });
//         }
//       } else {
//         next();
//       }
//     }
//   } else if (to.matched.some((record) => record.meta.guest)) {
//     if (localStorage.getItem("jwt") == null) {
//       next();
//     } else {
//       next({ name: "userboard" });
//     }
//   } else {
//     next();
//   }
// });

export default router;
